export default __webpack_public_path__ + "static/media/book.24178c26.png";